import React from 'react';
import UkMapLeaflet from './UkMapLeaflet.js';
import './UkMapWrapper.css';

function UkMapWrapper({ data }) {
  const mapHeight = () =>
    window.innerHeight <= 600 ? (window.innerHeight - 75) + "px" : "600px";    

  return (
    <section className="UkMapWrapper">
      <UkMapLeaflet mapHeight={mapHeight()} data={data} />
      <div className="ukmapwrapper-content">
        <div style={{ padding: '0px 10px 0px 10px' }}>
            <p>The above map shows the locations of all major projects currently going through the approval process.</p>
        </div>
      </div>
    </section>
  );
}

export default UkMapWrapper;
